import { useMemo } from "react";

import { type OptionItem, OptionType, useGetOptionsQuery } from "@/api/admin";
import { formatEnumValue } from "@/utils/formatEnumValue";

export const usePartnerOptions = (extraTypes: OptionType[] = []) => {
  const optionTypes = useMemo(
    () => [
      OptionType.PartnerRoles,
      OptionType.PartnerAssignmentsLevel,
      ...extraTypes,
    ],
    [extraTypes]
  );

  const { data: optionsData, isPending: isOptionPending } =
    useGetOptionsQuery(optionTypes);

  const rolesList: OptionItem[] = useMemo(() => {
    return (
      optionsData?.partnerRoles?.map(role => ({
        id: role,
        name: formatEnumValue(role),
      })) ?? []
    );
  }, [optionsData]);

  const levelsList: OptionItem[] = useMemo(() => {
    return (
      optionsData?.partnerAssignmentLevel?.map(level => ({
        id: level,
        name: formatEnumValue(level),
      })) ?? []
    );
  }, [optionsData]);

  return {
    optionsData,
    isOptionPending,
    rolesList,
    levelsList,
  };
};
